import React, { memo } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'


const Logo = () => {

  return (
    <Container>
      <Row>
        <Col sm={12}>
          <Stack direction='horizontal' gap={1} className='justify-content-center mb-4'>
              <h1 className='text-center mt-5 h1 display-1 header-txt-shadow text-dark'><strong><em>SHYNZ BY ONYX</em></strong></h1>
          </Stack>
        </Col>
      </Row>
    </Container>

  )
}

export default memo(Logo);